import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LegalComercioProvider } from "./context/LegalComercioContext";
import App from "./App";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LegalComercioProvider>
          <App />
        </LegalComercioProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
